<template>
    <div v-if="dialogVisible" class="downing_btn" :class="{'download_complete': downloadComplete}">
        <img :src="downloadComplete ? completeSrc : downloadIng" alt />
        <span class="video_download_title SysFontR">{{ downloadTitle }}</span>
        <img
            v-if="downloadComplete"
            src="@i/common/close.svg"
            class="close"
            alt
            @click="closeDialog"
        />
    </div>
</template>

<script>
/**
 * ComponentName: 下载视频提示弹窗
 * Created Date:2022/4/7
 * Author: dhg
 * Modifier: dhg
 * 组件说明：
 * 传值：
 *     属性名    类型      说明
 * eg:
 *     <vi-download-tip></vi-download-tip>
 */
export default {
    name: 'cl-download-tip',
    props: {
        // 弹窗显示隐藏
        dialogVisible: {
            type: Boolean,
            default: false
        },
        // 弹窗宽度
        width: {
            type: String,
            default: '360px'
        },
        // 弹窗标题
        downloadTitle: {
            type: String,
            default: function () {
                return this.$t('video.下载中请稍侯')
            }
        },
        // 是否下载完成
        downloadComplete: {
            type: Boolean,
            default: false
        },
        // 下载中的图片路径
        downloadIng: {
            type: String,
            default: function () {
                return require('@i/video/download_video.gif');
            }
        },
        // 下载完成的图片路径
        completeSrc: {
            type: String,
            default: function () {
                return require('@i/common/success.svg');
            }
        },
        // 提示文案
        text: {
            type: String,
            default: function () {
                let defaultText = this.$t('common.注意') + this.$t('classifier.视频短片默认保存到桌面');
                return defaultText;
            }
        }
    },
    methods: {
        // 关闭弹窗
        closeDialog () {
            this.$emit('update:dialogVisible', false);
        }
    }
}
</script>

<style lang='scss' scoped>
.downing_btn {
    min-width: 126px;
    height: 36px;
    position: fixed;
    bottom: 24px;
    right: 24px;
    z-index: 2000;
    background-color: #fff;
    border-radius: 18px;
    color: #3a3a3a;
    filter: drop-shadow(0px 16px 16px rgba(0, 50, 174, 0.08));
    display: flex;
    align-items: center;
    overflow: hidden;
    padding-right: 5px;
    &.download_complete {
        min-width: 100px;
        padding: 0 6px;
        img {
            width: 24px;
            height: 24px;
            margin-right: 6px;
        }
        .close {
            width: 10px;
            height: 10px;
            margin-left: 8px;
            cursor: pointer;
        }
    }
    .video_download_title {
        color: $base-font-minor;
        font-size: 12px;
        line-height: 17px;
    }
    img {
        width: 36px;
        height: 36px;
    }
}
</style>